import { Sidebar as SidebarComponent, TSidebarItemBaseProps } from '@chocolate-soup-inc/cs-frontend-components';
import reactDomJSON from 'react-dom/package.json';
import { generatePath } from 'react-router-dom';
import routerJSON from 'react-router-dom/package.json';
import reactJSON from 'react/package.json';
import tsJSON from 'typescript/package.json';
import {
  CLIENT_ONE_OFF_PATH,
  COMPANIES_PATH,
  COMPANIES_PATH_NEW,
  EMPLOYEES_PATH,
  EMPLOYEES_PATH_NEW,
  EVENTS_PATH,
  GIFT_PACKAGES_PATH,
  GIFT_PRODUCTS_PATH,
  GIFTS_PATH,
  HOME_PATH,
  HOME_PATH_NEW,
  IMPORT_LIST_PATH,
  IMPORT_LIST_PATH_NEW,
  IMPORT_PATH,
  LOGS_PATH,
  LOGS_PATH_NEW,
  NEW_HIRES_PATH,
  NEW_HIRES_PATH_NEW,
  NEW_PATH,
  OFFICE_PATH,
  OFFICE_PATH_NEW,
  ONE_OFF_PATH,
  ONE_OFF_PATH_NEW,
  REPORTS_PATH,
  SET_FOR_PICKUP_PATH,
  SET_FOR_PICKUP_PATH_NEW,
  SHIPMENTS_PATH,
  SHIPMENTS_PATH_NEW,
  SKIPPED_PATH,
  SKIPPED_PATH_NEW,
  SUBSCRIPTIONS_PATH,
  SUBSCRIPTIONS_PATH_NEW,
  TRACKING_PATH,
  TRACKING_PATH_NEW
} from '../../routes/paths';

type TSections = {
  items?: TSidebarItemBaseProps[] | null | undefined;
  title?: null | string;
}[];

const EXPERIMENTAL_SECTIONS: TSections = [
  { title: ' ' },
  {
    title: '=== EXPERIMENTAL ===',
    items: [
      {
        icon: 'domain',
        label: 'Companies NEW',
        path: generatePath(`${COMPANIES_PATH_NEW}`)
      },
      {
        icon: 'group',
        label: 'Employees NEW',
        path: generatePath(`${EMPLOYEES_PATH_NEW}`)
      },
      {
        icon: 'backup_table',
        label: 'Imports NEW',
        path: generatePath(`${EMPLOYEES_PATH}/${IMPORT_LIST_PATH_NEW}`)
      },
      {
        icon: 'history',
        label: 'Changelog NEW',
        path: generatePath(`${LOGS_PATH_NEW}`)
      }
    ]
  },
  {
    title: 'Upcoming Events',
    items: [
      /*{
        icon: 'event_repeat',
        label: 'Subscriptions',
        path: generatePath(`${EVENTS_PATH}/${HOME_PATH_NEW}`)
      },*/
      {
        icon: 'home',
        label: 'Home NEW',
        path: generatePath(`${EVENTS_PATH}/${HOME_PATH_NEW}`)
        //indent: 1
      },
      {
        icon: 'domain',
        label: 'Office NEW',
        path: generatePath(`${EVENTS_PATH}/${OFFICE_PATH_NEW}`)
        //indent: 1
      },
      {
        icon: 'group_add',
        label: 'New Hires NEW',
        path: generatePath(`${EVENTS_PATH}/${NEW_HIRES_PATH_NEW}`)
      },
      /*{
        icon: 'redeem',
        label: 'One-Off NEW',
        path: generatePath(`${EVENTS_PATH}/${ONE_OFF_PATH_NEW}`),
      }, */
      {
        icon: 'event_busy',
        label: 'Skipped NEW',
        path: generatePath(`${EVENTS_PATH}/${SKIPPED_PATH_NEW}`)
      }
    ]
  },
  {
    title: 'Gift Assembling',
    items: [
      {
        icon: 'event_repeat',
        label: 'Subscriptions NEW',
        path: generatePath(`${GIFTS_PATH}/${SUBSCRIPTIONS_PATH_NEW}`)
      },
      {
        icon: 'group_add',
        label: 'New Hires NEW',
        path: generatePath(`${GIFTS_PATH}/${NEW_HIRES_PATH_NEW}`)
      },
      {
        icon: 'redeem',
        label: 'One-Off NEW',
        path: generatePath(`${GIFTS_PATH}/${ONE_OFF_PATH_NEW}`)
      }
      /*{
        icon: 'quiz',
        label: 'Orphan NEW',
        path: generatePath(`${GIFTS_PATH}/${ORPHAN_PATH_NEW}`)
      }*/
    ]
  },
  {
    title: 'Shipments',
    items: [
      {
        icon: 'package',
        label: 'Shipments NEW',
        path: generatePath(`${SHIPMENTS_PATH_NEW}`)
      },
      {
        icon: 'delivery_truck_speed',
        label: 'Tracking NEW',
        path: generatePath(`${SHIPMENTS_PATH}/${TRACKING_PATH_NEW}`)
      },
      {
        icon: 'hand_package',
        label: 'Pickup NEW',
        path: generatePath(`${SHIPMENTS_PATH}/${SET_FOR_PICKUP_PATH_NEW}`)
      }
    ]
  }
];

const SECTIONS: TSections = [
  {
    title: import.meta.env.REACT_APP_STAGE != 'production' ? `React ${reactJSON.version}; DOM ${reactDomJSON.version}; Router ${routerJSON.version}; TS ${tsJSON.version};` : undefined,
    items: [
      {
        icon: 'domain',
        label: 'Companies',
        path: generatePath(`${COMPANIES_PATH}`)
      },
      {
        icon: 'add_circle',
        label: 'New company',
        path: generatePath(`${COMPANIES_PATH}/${NEW_PATH}`),
        indent: 1
      },
      /*{
        icon: 'monitoring',
        label: 'Reports',
        path: generatePath(`${COMPANIES_PATH}/${REPORTS_PATH}`),
        indent: 1
      },*/
      {
        icon: 'backup',
        label: 'Import Roster',
        path: generatePath(`${EMPLOYEES_PATH}/${IMPORT_PATH}`),
        indent: 1
      },
      {
        icon: 'backup_table',
        label: 'Import History',
        path: generatePath(`${EMPLOYEES_PATH}/${IMPORT_LIST_PATH}`)
      },
      {
        icon: 'history',
        label: 'Changelog',
        path: generatePath(`${LOGS_PATH}`)
      },
      {
        icon: 'group',
        label: 'Employees',
        path: generatePath(`${EMPLOYEES_PATH}`)
      }
    ]
  },
  {
    title: 'Upcoming Events',
    items: [
      {
        icon: 'event_repeat',
        label: 'Subscriptions',
        path: generatePath(`${EVENTS_PATH}`)
      },
      {
        icon: 'home',
        label: 'Home',
        path: generatePath(`${EVENTS_PATH}/${HOME_PATH}`),
        indent: 1
      },
      {
        icon: 'domain',
        label: 'Office',
        path: generatePath(`${EVENTS_PATH}/${OFFICE_PATH}`),
        indent: 1
      },
      {
        icon: 'group_add',
        label: 'New Hires',
        path: generatePath(`${EVENTS_PATH}/${NEW_HIRES_PATH}`)
      },
      {
        icon: 'redeem',
        label: 'One-Off',
        path: generatePath(`${EVENTS_PATH}/${ONE_OFF_PATH}`)
      },
      {
        icon: 'add_circle',
        label: 'New one-off',
        path: generatePath(`${EVENTS_PATH}/${ONE_OFF_PATH}/${NEW_PATH}`),
        indent: 1
      },
      {
        icon: 'redeem',
        label: 'Client One-off',
        path: generatePath(`${EVENTS_PATH}/${CLIENT_ONE_OFF_PATH}`)
      },
      {
        icon: 'event_busy',
        label: 'Skipped',
        path: generatePath(`${EVENTS_PATH}/${SKIPPED_PATH}`)
      },
      {
        icon: 'assessment',
        label: 'Reports',
        path: generatePath(`${EVENTS_PATH}/${REPORTS_PATH}`)
      }
    ]
  },
  {
    title: 'Gift Assembling',
    items: [
      {
        icon: 'event_repeat',
        label: 'Subscriptions',
        path: generatePath(`${GIFTS_PATH}/${SUBSCRIPTIONS_PATH}`)
      },
      {
        icon: 'group_add',
        label: 'New Hires',
        path: generatePath(`${GIFTS_PATH}/${NEW_HIRES_PATH}`)
      },
      {
        icon: 'redeem',
        label: 'One-Off',
        path: generatePath(`${GIFTS_PATH}/${ONE_OFF_PATH}`)
      },
      /*{
        icon: 'quiz',
        label: 'Orphan',
        path: generatePath(`${GIFTS_PATH}/${ORPHAN_PATH}`)
      },*/
      {
        icon: 'assessment',
        label: 'Reports',
        path: generatePath(`${GIFTS_PATH}/${REPORTS_PATH}`)
      }
    ]
  },
  {
    title: 'Shipments',
    items: [
      {
        icon: 'package',
        label: 'Shipments',
        path: generatePath(`${SHIPMENTS_PATH}`)
      },
      {
        icon: 'delivery_truck_speed',
        label: 'Tracking',
        path: generatePath(`${SHIPMENTS_PATH}/${TRACKING_PATH}`)
      },
      {
        icon: 'hand_package',
        label: 'Pickup',
        path: generatePath(`${SHIPMENTS_PATH}/${SET_FOR_PICKUP_PATH}`)
      },
      {
        icon: 'assessment',
        label: 'Reports',
        path: generatePath(`${SHIPMENTS_PATH}/${REPORTS_PATH}`)
      }
    ]
  },
  {
    title: 'Gift Packages',
    items: [
      {
        icon: 'two_pager_store',
        label: 'Packages',
        path: generatePath(`${GIFTS_PATH}/${GIFT_PACKAGES_PATH}`)
      },
      {
        icon: 'add_circle',
        label: 'New package',
        path: generatePath(`${GIFTS_PATH}/${GIFT_PACKAGES_PATH}/${NEW_PATH}`),
        indent: 1
      },
      {
        icon: 'inventory',
        label: 'Products',
        path: generatePath(`${GIFTS_PATH}/${GIFT_PRODUCTS_PATH}`)
      },
      {
        icon: 'add_circle',
        label: 'New product',
        path: generatePath(`${GIFTS_PATH}/${GIFT_PRODUCTS_PATH}/${NEW_PATH}`),
        indent: 1
      }
    ]
  }
];

const isProd = import.meta.env.REACT_APP_STAGE?.toLowerCase() == 'production';

export const Sidebar = () => {
  //console.log('import.meta.env?:', import.meta.env);
  return (
    <SidebarComponent
      title={`Internal Portal ${!isProd ? `[${import.meta.env.REACT_APP_STAGE?.toUpperCase()}]` : ''}`}
      sections={[
        ...SECTIONS,
        // === EXPERIMENTAL ===
        ...EXPERIMENTAL_SECTIONS
        //...(!isProd ? EXPERIMENTAL_SECTIONS : []),
      ]}
    />
  );
};
